import { SheetsRepository } from '../infrastructure/sheets.repository.js';
import { checkCapacity } from '../shared/reservation-policy.js';
import { PERSONAS_MIN, PERSONAS_MAX } from '../shared/constants.js';

/**
 * Servicio encargado de la lógica de negocio de las reservas.
 */
export const ReservationService = {
    /**
     * Valida y procesa una reserva.
     */
    async book(reservaData) {
        // 1. Validación de dominio
        const validation = this._validate(reservaData);
        if (!validation.ok) throw new Error(validation.error);

        // 2. Persistencia vía infraestructura
        try {
            const result = await SheetsRepository.saveReserva(reservaData);
            return result;
        } catch (error) {
            window.Sentry?.captureException(error);
            throw error;
        }
    },

    /**
     * Consulta disponibilidad combinando reglas de negocio y datos de infraestructura.
     */
    async checkDisponibilidad(fecha, momento, area, personas) {
        const ocupacion = await SheetsRepository.getOcupacion(fecha, momento, area);
        const { ok, remaining } = checkCapacity({ ocupacionActual: ocupacion, personas, area });
        return {
            disponible: ok,
            lugaresRestantes: remaining + personas, // seats left before this booking
        };
    },

    /**
     * Reglas de validación de negocio.
     */
    _validate(data) {
        if (!data.nombre || !data.apellido) return { ok: false, error: "Nombre y apellido son obligatorios" };
        if (data.personas < PERSONAS_MIN || data.personas > PERSONAS_MAX) return { ok: false, error: `La reserva debe ser para entre ${PERSONAS_MIN} y ${PERSONAS_MAX} personas` };
        if (!data.fecha) return { ok: false, error: "Fecha obligatoria" };
        return { ok: true };
    }
};
